// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionPlayList_wrapper__CUaTi"};